import React, { useCallback, useReducer } from 'react';
import { Form } from 'react-bootstrap';
import { confirm } from "react-confirm-box";
import { CSVLink } from "react-csv";
import { useEffect, useState } from "react";
import { UserPermissionList, LOBList, ProductList, ServicesList, BDList, SDList, LocationsData, ZoneData, CategoryData, CommodityData, SolutionTypeData, ProjectData, CreatedByData} from '../../apidata/fetchapi';
import { useNavigate,NavLink, Link } from 'react-router-dom';
import { ulmsUrl } from '../../Api';
import { password, username } from '../../Api';
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import Loader from '../../loader/Loader';
import DateFormat from '../dateformate/DateFormat';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';


const BackendLead = () => {

    const { permissionList }   = UserPermissionList();
    const { lobListData }      = LOBList();
    const { productListData }  = ProductList();
    const { servicesListData } = ServicesList();
    const { bdListData }       = BDList();
    const { sdListData }       = SDList();
    const { locationDropdown } = LocationsData();
    const { zoneDropdown }     = ZoneData();
    const { categoryDropdown } = CategoryData();
    const { commedityDropdown } = CommodityData();
    const { solutionTypeDropdown } = SolutionTypeData();
    const { projectNameDropdown }  = ProjectData();
    const { createdByDropdown }    = CreatedByData();

    let base64          = require('base-64');
    const navigate      = useNavigate();
    const usr_token     = localStorage.getItem('authToken');
    const user_id       = localStorage.getItem('usrId');
    const isUserLogin   = localStorage.getItem('isAuthenticatedUser');
    let message         = sessionStorage.getItem("createmessage");

    let productname = sessionStorage.getItem("productnamebackenddash");
    let productnamebknddash = JSON.parse(productname);

    let servicename = sessionStorage.getItem("servicenamebackenddash");
    let servicenamebknddash = JSON.parse(servicename);

    let projectname = sessionStorage.getItem("projectnamebackenddash");
    let projectnamebknddash = JSON.parse(projectname);

    let locationname = sessionStorage.getItem("locationnamebackenddash");
    let locationnamebknddash = JSON.parse(locationname);

    let zonename = sessionStorage.getItem("zonenamebackenddash");
    let zonenamebknddash = JSON.parse(zonename);

    let categoryname = sessionStorage.getItem("categorynamebackenddash");
    let categorynamebknddash = JSON.parse(categoryname);

    let commodityname = sessionStorage.getItem("commoditynamebackenddash");
    let commoditynamebknddash = JSON.parse(commodityname);

    let solutiontypename = sessionStorage.getItem("solutiontypebackenddash");
    let solutiontypebknddash = JSON.parse(solutiontypename);

    let createdbyname = sessionStorage.getItem("createdbybackenddash");
    let createdbybknddash = JSON.parse(createdbyname);

    const autoColumns = [
      { 
        name: "Lead Id",
        selector : (row) => row.id ,
        width : '89px',
        sortable :  true 
      },
      {
        name: "LOB",
        sortable :  true,  
        width : '80px',
        selector : (row) => row.lob_type,
      },
      {
        name: "Product Type",
        sortable :  true,  
        width : '125px',
        selector : (row) => row.inventory_type,
      },
      {
        name: "Services",
        sortable :  true,  
        width : '95px',
        selector : (row) => row.service_type,
      },
      {
        name: "Project ID",
        sortable :  true,  
        width : '140px',
        selector : (row) => row.project_id,
      },
      {
        name: "Supplier Name",
        sortable :  true,  
        width : '220px',
        selector : (row) => {
          if(row.supplier_name != null && row.supplier_name_id != 666666){
            return(
                <div>{row.supplier_name}</div>
            )
          }else if(row.new_supplier_name != null && row.supplier_name_id == 666666){
            return(
                <div>{row.new_supplier_name}</div>
            )
          }else{
            return(
              <div>-</div>
            )
          }
        },
        wrap: true
      },
      {
        name: "OEM Name",
        sortable :  true,  
        width : '220px',
        selector : (row) => 
        {
          if(row.service_type == 'RP' && row.oem_name != null && row.oem_name_id != 666666){
            return(
                <div>{row.oem_name }</div>
            )
          }else if(row.service_type == 'RP' && row.new_oem_name != null && row.oem_name_id == 666666){
            return(
                <div>{row.new_oem_name}</div>
            )
          }else{
            return(
              <div>-</div>
            )
          }
        },
        wrap: true
      },
      {
        name: "Component Name",
        sortable :  true,
        width : '150px',
        selector : (row) => row.component_name,
        wrap: true  
      },
      {
        name: "BD Name",
        sortable :  true,
        width : '110px',
        selector : (row) => row.bd_person_name,
        wrap: true  
      },
      {
          name: "SD Name",
          sortable :  true,
          width : '110px',
          selector : (row) => row.sd_person_name,
          wrap: true  
      },
      {
        name: "Created At",
        sortable :  true,
        width : '115px',
        selector : (row) => DateFormat(row.created_at)
      },
      {
        name: "Status",
        sortable :  true,  
        width : '90px',
        selector : (row) =>
        {
          return(
              <span className="text-success">{row.status}</span>
          )
        },
        wrap: true    
      },
      {
        name: "View",
        width : '150px',
        cell : (row) => 
        {
          return(
              <>
                  {/* <Link to={`/backend_leadedit/${base64.encode(row.id)}/${row.lob_type}`} ><span className='badge bg-primary' > Edit</span></Link>  */}
                  <Link to={`/backend_leadview/${base64.encode(row.id)}`}  style={{marginLeft: '10px'}} ><span className='badge bg-primary' > View</span></Link> 
              </>
          )
        }
      }, 
  ];

  const retailColumns = [
    { 
      name: "Lead Id",
      selector : (row) => row.id ,
      width : '89px',
      sortable :  true 
    },
    {
      name: "LOB",
      sortable :  true,  
      width : '80px',
      selector : (row) => row.project_type,
    },
    {
      name: "Product Type",
      sortable :  true,  
      width : '125px',
      selector : (row) => row.products,
    },
    {
      name: "Services",
      sortable :  true,  
      width : '95px',
      selector : (row) => row.service_type,
    },
    {
      name: "Project ID",
      sortable :  true,  
      width : '120px',
      selector : (row) => row.project_id,
    },
    {
      name: "Project Name",
      sortable :  true,  
      width : '150px',
      selector : (row) => row.project_name,
      wrap: true
    },
    {
      name: "Location Name",
      sortable :  true,  
      width : '150px',
      selector : (row) => row.location_name,
      wrap: true
    },
    {
      name: "Zone Name",
      sortable :  true,
      width : '120px',
      selector : (row) => row.zone,
      wrap: true  
    },
    {
      name: "Category Name",
      sortable :  true,
      width : '150px',
      selector : (row) => row.categories_name,
      wrap: true  
    },
    {
      name: "Solution Type",
      sortable :  true,
      width : '130px',
      selector : (row) => row.solution_type,
      wrap: true  
    },
    {
        name: "Commodity",
        sortable :  true,
        width : '110px',
        selector : (row) => row.commodity,
        wrap: true  
    },
    {
      name: "Created By",
      sortable :  true,
      width : '110px',
      selector : (row) => row.CreatedBy,
      wrap: true  
    },
    {
      name: "Created At",
      sortable :  true,
      width : '115px',
      selector : (row) => DateFormat(row.created_at)
    },
   
    {
      name: "View",
      width : '150px',
      cell : (row) => 
      {
        return(
            <>
                {/* <Link to={`/backend_leadedit/${base64.encode(row.id)}/${row.project_type}`} ><span className='badge bg-primary' > Edit</span></Link>  */}
                <Link to={`/backend_retailview/${base64.encode(row.id)}`} style={{marginLeft: '10px'}} ><span className='badge bg-primary' > View</span></Link> 
            </>
        )
      }
    }, 
  ];


    const leaddataurl                               = '/backend/data_list';
    const [leadId, setLeadId]                       = React.useState('');
    const [search ,setSearch]                       = React.useState("");
    const [filteredLeads ,setFilteredLeads]         = React.useState([]);
    const [ isAlertVisible, setIsAlertVisible]      = React.useState(true);
    const [isusermessage, issetMessage]             = React.useState(null);
    const [dashboardLeadData, setDashboardLeadData] = React.useState([""]);
    const [reportLeadData, setReportLeadData]       = React.useState([]);
    const [loading, setLoading]                     = useState(true);    
    const [selectLobData, setSelectLobData]         = useState("AUTO");
    const [columns, setColumns]                     = useState(autoColumns);
    const [dropdownData, setDropdownData]           = useState({

      product_name   : productnamebknddash,
      service_name   : servicenamebknddash,
      project_name   : projectnamebknddash,
      location_name  : locationnamebknddash,
      zone_name      : zonenamebknddash,
      category_name  : categorynamebknddash,
      commodity_name : commoditynamebknddash,
      solution_type  : solutiontypebknddash,
      createdby_name : createdbybknddash,
      usr_token: usr_token,
      lead_status: 0,
      project_type: "AUTO",
    });

    const handleProductInput = (data) => {
        sessionStorage.removeItem("productnamebackenddash");
        sessionStorage.setItem("productnamebackenddash", JSON.stringify(data));
    
        setDropdownData((oldValue) => ({
            ...oldValue,
            product_name: data,
        }));
    };
  
    const handleServicesInput = (data) => {
        sessionStorage.removeItem("servicenamebackenddash");
        sessionStorage.setItem("servicenamebackenddash", JSON.stringify(data));
  
        setDropdownData((oldValue) => ({
            ...oldValue,
            service_name: data,
        }));
    };

    const handleProjectInput = (data) => {
        sessionStorage.removeItem("projectnamebackenddash");
        sessionStorage.setItem("projectnamebackenddash", JSON.stringify(data));

        setDropdownData((oldValue) => ({
            ...oldValue,
            project_name: data,
        }));
    };

    const handleLoactionInput = (data) => {
        sessionStorage.removeItem("locationnamebackenddash");
        sessionStorage.setItem("locationnamebackenddash", JSON.stringify(data));

        setDropdownData((oldValue) => ({
            ...oldValue,
            location_name: data,
        }));
    };

    const handleZoneInput = (data) => {
        sessionStorage.removeItem("zonenamebackenddash");
        sessionStorage.setItem("zonenamebackenddash", JSON.stringify(data));

        setDropdownData((oldValue) => ({
            ...oldValue,
            zone_name: data,
        }));
    };

    const handleCategoryInput = (data) => {
        sessionStorage.removeItem("categorynamebackenddash");
        sessionStorage.setItem("categorynamebackenddash", JSON.stringify(data));

        setDropdownData((oldValue) => ({
            ...oldValue,
            category_name: data,
        }));
    };

    const handleCommodityInput = (data) => {
        sessionStorage.removeItem("commoditynamebackenddash");
        sessionStorage.setItem("commoditynamebackenddash", JSON.stringify(data));

        setDropdownData((oldValue) => ({
            ...oldValue,
            commodity_name: data,
        }));
    };

    const handleSolutionTypeInput = (data) => {
        sessionStorage.removeItem("solutiontypebackenddash");
        sessionStorage.setItem("solutiontypebackenddash", JSON.stringify(data));

        setDropdownData((oldValue) => ({
            ...oldValue,
            solution_type: data,
        }));
    };

    const handleCreatedByInput = (data) => {
        sessionStorage.removeItem("createdbybackenddash");
        sessionStorage.setItem("createdbybackenddash", JSON.stringify(data));

        setDropdownData((oldValue) => ({
            ...oldValue,
            createdby_name: data,
        }));
    };

    const clearFilter = () =>{
      sessionStorage.removeItem("productnamebackenddash");
      sessionStorage.removeItem("servicenamebackenddash");
      sessionStorage.removeItem("projectnamebackenddash");
      sessionStorage.removeItem("locationnamebackenddash");
      sessionStorage.removeItem("zonenamebackenddash");
      sessionStorage.removeItem("categorynamebackenddash");
      sessionStorage.removeItem("commoditynamebackenddash");
      sessionStorage.removeItem("solutiontypebackenddash");
      sessionStorage.removeItem("createdbybackenddash");
  
      setDropdownData({
        product_name   : "",
        service_name   : "",
        project_name   : "",
        location_name  : "",
        zone_name      : "",
        category_name  : "",
        commodity_name : "",
        solution_type  : "",
        createdby_name : "",
        usr_token: usr_token,
        lead_status: 0,
        project_type: "AUTO",
      })
      getDashBoardLeadsData();
    }


    const handleCategoryChange = (event) => {
         console.log(event.target.value);
         const newValue = event.target.value;
         setSelectLobData(newValue);
         setDropdownData((prev) => ({
          ...prev,
          project_type: newValue,
        }));

        if (newValue === "AUTO") {
          setColumns(autoColumns);
          // setFilteredLeads(autoData);
        } else if (newValue === "RETAIL") {
          setColumns(retailColumns);
          // setFilteredLeads(retailData);
        }
    };

    const getDashBoardLeadsData = async () => {
        console.log('dropdown',JSON.stringify(dropdownData));
        // setLoading(true);
              
        try {
            fetch(ulmsUrl.concat(leaddataurl) , {
                method: 'POST',
                body: JSON.stringify(dropdownData),
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then((response) =>
                response.json()
            )
            .then((response) => {  
                setLoading(false);
                let result = response.data;
                console.log('filter',result);
                setDashboardLeadData(result)
                setFilteredLeads(response.data);
            });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getDashBoardLeadsData();
    }, [dropdownData]);
  
    console.log(filteredLeads);
    console.log(dashboardLeadData);
  
    useEffect(() => {

      const isNumber = !isNaN(search);
      const searchLower = search?.toLowerCase();

      if(selectLobData == 'AUTO'){

        const filterResult = dashboardLeadData.filter(data => {
          return (isNumber && data.id === Number(search) || data.project_type?.toLowerCase().match(searchLower) || data.products?.toLowerCase().match(searchLower) || data.service_type?.toLowerCase().match(searchLower) || data.supplier_name?.toLowerCase().match(searchLower) || data.oem_name?.toLowerCase().match(searchLower) || data.cust_industry_verticle?.toLowerCase().match(searchLower) || data.lead_req_name?.toLowerCase().match(searchLower) || "");  
        });
        setFilteredLeads(filterResult);

      }else if(selectLobData == 'RETAIL'){

        const filterResult = dashboardLeadData.filter(data => {
          return (isNumber && data.id === Number(search) || data.project_id?.toLowerCase().match(searchLower) || data.project_type?.toLowerCase().match(searchLower) || data.products?.toLowerCase().match(searchLower) || data.service_type?.toLowerCase().match(searchLower) || data.project_name?.toLowerCase().match(searchLower) || data.location_name?.toLowerCase().match(searchLower) || data.zone?.toLowerCase().match(searchLower) || data.categories_name?.toLowerCase().match(searchLower) || data.commodity?.toLowerCase().match(searchLower) || "");  
        });
        setFilteredLeads(filterResult);

      }
     
    }, [search]); 

    useEffect(() => {
      if(message != ''){
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'success1',
        });  
      }
      setTimeout(() => {
        sessionStorage.removeItem('createmessage');
      }, 8000); 
    }, []); 


  return (
    <>
        <ToastContainer />
        {loading && (
            <>
            <Loader/>
            </>
        ) }
        <div className="row">
            <div className="order-2 order-lg-1 col-lg-12 bd-content">
                <div className="card">
                    <div className="card-header">
                      <div className='row'>
                        <div className='col-md-12'>
                          <h3 className="card-title" style={{float:'left'}}> BACKEND LEADS</h3> 
                          <button style={{font_size: '12px', float: 'right'}} type="button" onClick={clearFilter} className="btn btn-danger btn-sm  me-2"><strong>Clear Filter</strong></button>   
                          {/* <button style={{font_size: '12px', float: 'right'}} type="button" onClick={addLead} className="btn btn-primary btn-sm  me-2"><strong>Create Lead</strong></button>     */}
                          <CSVLink style={{font_size: '12px', float: 'right'}} className="btn btn-success btn-sm  me-2" 
                          data={filteredLeads}
                          filename={"backend_leads.csv"}
                          ><strong>Export</strong></CSVLink>
                        </div>
                        <div className='col-md-12'>
                          <Form.Check
                              inline
                              label="AUTO"
                              name="project_type"
                              value="AUTO"
                              type= "radio"
                              checked={selectLobData === "AUTO"}
                              onChange={handleCategoryChange}
                              id={`inline-radio-2`}
                          />
                          <Form.Check
                              inline
                              label="RETAIL"
                              name="project_type"
                              value="RETAIL"
                              type= "radio"
                              // onClick={()=>setSelectLobData("RETAIL")}
                              checked={selectLobData === "RETAIL"}
                              onChange={handleCategoryChange}
                              id={`inline-radio-1`}
                          />
                          </div>
                        </div>
                    </div>
                    <div style={{marginLeft:'10px', marginRight:'10px'}}>
                        <form className="row"  encType="multipart/form-data">  
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Product :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="supplier_name"
                                    options={productListData}
                                    defaultValue={productnamebknddash}
                                    key={productnamebknddash}
                                    onChange={handleProductInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Services :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="supplier_name"
                                    options={servicesListData}
                                    defaultValue={servicenamebknddash}
                                    key={servicenamebknddash}
                                    onChange={handleServicesInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Project Name :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="project_name"
                                    options={projectNameDropdown}
                                    defaultValue={projectnamebknddash}
                                    key={projectnamebknddash}
                                    onChange={handleProjectInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Location Name :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="location_name"
                                    options={locationDropdown}
                                    defaultValue={locationnamebknddash}
                                    key={locationnamebknddash}
                                    onChange={handleLoactionInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Zone :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="zone_name"
                                    options={zoneDropdown}
                                    defaultValue={zonenamebknddash}
                                    key={zonenamebknddash}
                                    onChange={handleZoneInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                     Category Name :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="category_name"
                                    options={categoryDropdown}
                                    defaultValue={categorynamebknddash}
                                    key={categorynamebknddash}
                                    onChange={handleCategoryInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                     Commodity:{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="commodity"
                                    options={commedityDropdown}
                                    defaultValue={commoditynamebknddash}
                                    key={commoditynamebknddash}
                                    onChange={handleCommodityInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Solution Type:{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="solution_type"
                                    options={solutionTypeDropdown}
                                    defaultValue={solutiontypebknddash}
                                    key={solutiontypebknddash}
                                    onChange={handleSolutionTypeInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                     Created By:{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="created_by"
                                    options={createdByDropdown}
                                    defaultValue={createdbybknddash}
                                    key={createdbybknddash}
                                    onChange={handleCreatedByInput}
                                />
                            </div>
                        </form>
                    </div>
                    {/* <div style={{marginLeft:'10px', marginRight:'10px'}}>
                        <form className="row"  encType="multipart/form-data">  
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Date :{" "}
                                </label>
                                <DateRangePicker 
                                block 
                                style={{ width: 230, borderColor: '#cccccc', borderRadius : '4px', borderStyle:'solid', borderWidth:'1px', boxSizing: 'border box'}} 
                                name="date" 
                                onChange={handleDateSelect}
                                defaultValue={datemydash}
                                key={datemydash}
                                />
                            </div>                        
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    LOB Name :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="supplier_name"
                                    options={lobListData}
                                    defaultValue={lobnamemydash}
                                    key={lobnamemydash}
                                    onChange={handleLOBNameInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Product :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="supplier_name"
                                    options={productListData}
                                    defaultValue={productnamemydash}
                                    key={productnamemydash}
                                    onChange={handleProductInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Services :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="supplier_name"
                                    options={servicesListData}
                                    defaultValue={servicenamemydash}
                                    key={servicenamemydash}
                                    onChange={handleServicesInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    BD Name :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="supplier_name"
                                    options={bdListData}
                                    defaultValue={bdnamemydash}
                                    key={bdnamemydash}
                                    onChange={handleBDNameInput}
                                    // onChange={handleSuppNameInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Sol. Design Exe. :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="supplier_name"
                                    options={sdListData}
                                    defaultValue={sdnamemydash}
                                    key={sdnamemydash}
                                    onChange={handleSDNameInput}
                                    // onChange={handleSuppNameInput}
                                />
                            </div>
                            <div className="col-md-2" style={{ marginTop: "15px" }}>
                                <label htmlFor="inputState" className="form-label">
                                    Status :{" "}
                                </label>
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="status"
                                    options={statusarr}
                                    defaultValue={statusmydash}
                                    key={statusmydash}
                                    onChange={handleStatusInput}
                                    // onChange={handleSuppNameInput}
                                />
                            </div>
                        </form>
                    </div> */}
                     <div className="card-body">         
                            <DataTable 
                            id="table-to-xls"
                            paginationRowsPerPageOptions={[10,25,50,100,1000]}
                            data={filteredLeads} 
                            columns={columns} 
                            pagination
                            //fixedHeader
                            //fixedHeaderScrollHeight='500px'
                            highlightOnHover
                            subHeader
                            subHeaderComponent = {
                            <div className="col-md-3" style={{float:'right'}}>
                            <input type="text" 
                                placeholder='Search here' 
                                className='w-22 form-control'
                                value={search || ''}
                                onChange={(e)=> setSearch(e.target.value)}
                            />
                            </div>
                            }
                            />
                        
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                </div>
            </div>
        </div>
            
    </>
  )
}

export default BackendLead